import React from 'react';
import './loader.css';
const logo = 'http://lawina.boleslawiec.zhp.pl/assets/logos/lawina.webp';

export default function Loader() {
  return (
    <div className="loader-container">
      <img src={logo} alt="Ładowanie..." className="loader-logo" />
      <div className="spinner"></div>
    </div>
  );
}